import { createContext, useContext } from "react";

/**
 * Web origin of the GitHub instance the surrounding UI is about, e.g.
 * `https://ghe.example.com`: the listed orgs' instance under
 * `OrgUrlSyncProvider`, the session's installation's inside a session pane.
 * Null until the listing loads or when the backend omitted it.
 */
export const GithubWebOriginContext = createContext<string | null>(null);

export function useGithubWebOrigin(): string | undefined {
  return useContext(GithubWebOriginContext) ?? undefined;
}

/** `githubWebUrl("https://ghe.example.com", "acme/web/pull/4")` → `https://ghe.example.com/acme/web/pull/4`; undefined without an origin. */
export function githubWebUrl(
  origin: string | undefined,
  path: string,
): string | undefined {
  return origin ? `${origin}/${path}` : undefined;
}
